angular.module('bmsApp.accounting').controller('InvoiceIndexCtrl', function ($state,
																			   $scope,
																			   $timeout,
																			   $log,
																			   $filter,
																			   notify,
																			   AccountingSvc,
																			 LicenseOptionsSvc,
																			   $q,
																			   TGInvoiceSvc,
																			 $localStorage) {

	$scope.activeFilters = [];

	$scope.invoiceTypeOptions = [
	
	];

	var promises = {
		licenseOptions: LicenseOptionsSvc.license(),
		licenceTypeOptions: LicenseOptionsSvc.network(),
	};

	if ($scope.isTG()) {
		angular.extend(promises, {
			invoiceTypeOptions: TGInvoiceSvc.getInvoiceTypeOptions(),
		})
	}

	$q.all(promises)
		.then(function (response) {
			$scope.licenseOptions = response.licenseOptions.data.options;
			$scope.licenseTypeOptions = response.licenceTypeOptions.data.options;
			if ($scope.isTG()) {
				$scope.invoiceTypeOptions = response.invoiceTypeOptions.data.invoice_type_options;
			}
			$scope.loading = false;
		});



	$scope.customers = {
		loading: true,
		updating: true,
		pageResult: [] // currently loaded paged results
	};


	$scope.statusOptions = [
		{
			value: 0,
			label: 'All'
		},
		{
			value: 1,
			label: 'Overdue'
		},
		{
			value: 2,
			label: 'Paid'
		},
		{
			value: 3,
			label: 'Unpaid'
		},
		{
			value: 4,
			label: 'Credits'
		},
		{
			value: 5,
			label: 'Part Paid'
		}
	];

	$scope.sortOptions = [
		{
			id: 1,
			value: 'surname',
			label: 'Customer Surname (Asc)',
			dir: 'asc',
			type: 'customer'
		},
		{
			id: 2,
			value: 'surname',
			label: 'Customer Surname (Desc)',
			dir: 'desc',
			type: 'customer'
		},
		{
			id: 3,
			value: 'invoice_date',
			label: 'Invoice Date (Asc)',
			dir: 'asc',
			type: 'invoice'
		},
		{
			id: 4,
			value: 'invoice_date',
			label: 'Invoice Date (Desc)',
			dir: 'desc',
			type: 'invoice'
		}
	];

	var defaultInvoiceParams = function () {
		var defaultParams = {
			page: 1,
			count: 50,
			filters: {
				invoiceNumber: null,
				dateRange: {
					startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
					endDate: moment().format('YYYY-MM-DD')
				},
				customerName: null,
				status: angular.copy($scope.statusOptions[0]),
				sort: angular.copy($scope.sortOptions[0]),
				overdueBy: 0,
				licences: null,
				licenceType: null,
			}
		};

		if($scope.isTG()){
			angular.extend(defaultParams, {
				invoiceType : angular.copy($scope.invoiceTypeOptions['']), 
			});
		}

		return defaultParams;
	};

	var initialInvoiceParams = function () {
		if (angular.isDefined($localStorage.invoiceIndexParams)) {
			return angular.extend({}, defaultInvoiceParams(), $localStorage.invoiceIndexParams);
		}
		else {
			return angular.extend({}, defaultInvoiceParams());
		}
	};

	AccountingSvc.overdueStats().then((response) => {
		$scope.overdue14Stats = response.data.stats14;
		$scope.overdue30Stats = response.data.stats30;
		$scope.overdueInvoiceLoaded = true;
	});

	var params = initialInvoiceParams();

	// copy the filters to a workable state
	$scope.invoiceFilters = angular.copy(params.filters);

	$scope.$watch('invoiceParams', function (value) {
		loadInvoices();
		$scope.getActiveFilters();
	}, true);

	$scope.invoiceParams = angular.copy(params);

	function loadInvoices() {
		$scope.customers.updating = true;

		$localStorage.invoiceIndexParams = $scope.invoiceParams;
		AccountingSvc.index($scope.invoiceParams)
			.then(function (response) {
				$scope.customers.pageResult = response.data.customers;
				$scope.customers.totalCount = response.data.total.customers;
				$scope.totalInvoices = response.data.total.invoices;
				$scope.totalInvoicesPageResult = response.data.total.invoiceCountForPageResult;
				$scope.totalInPeriod = response.data.total.valueInPeriod ? response.data.total.valueInPeriod : 0;
				$scope.overdueInPeriod = response.data.total.valueOverdueInPeriod ? response.data.total.valueOverdueInPeriod : 0;

				// Check if we've exceeded our page size, if we have, go back to page 1
				if ($scope.totalInvoices > 0 && !$scope.customers.pageResult.length) {
					$scope.invoiceParams.page = 1;
				}
				$scope.customers.loading = false;
				$scope.customers.updating = false;
			});
	}

	$scope.filterApply = function () {
		angular.extend($scope.invoiceParams.filters, angular.copy($scope.invoiceFilters));
	};

	$scope.filterReset = function () {
		angular.extend($scope.invoiceParams, defaultInvoiceParams());
		angular.extend($scope.invoiceFilters, defaultInvoiceParams().filters);
	};

	$scope.getActiveFilters = function () {
		var filters = [];
		if ($scope.invoiceParams.filters.invoiceNumber != null && $scope.invoiceParams.filters.invoiceNumber != "") {
			filters.push({
				label: 'Invoice Number',
				value: $scope.invoiceParams.filters.invoiceNumber
			});
		}
		if ($scope.invoiceParams.filters.customerName != null && $scope.invoiceParams.filters.customerName != "") {
			filters.push({
				label: 'Customer',
				value: $scope.invoiceParams.filters.customerName
			});
		}
		if ($scope.invoiceParams.filters.status > 0) {
			var status = $filter('filter')($scope.statusOptions, {value: $scope.invoiceParams.filters.status})[0];
			filters.push({
				label: 'Status',
				value: status.label
			});
		}
		$scope.activeFilters = filters;
	};

	$scope.exportResults = function () {
		AccountingSvc.export($scope.invoiceParams);
	};

	$scope.paymentReceipt = function () {
		if (!$scope.paymentReceiptLoading) {
			AccountingSvc.showPaymentReceiptModal()
				.then(function (modalResult) {
					$scope.paymentReceiptLoading = true;
					AccountingSvc.savePaymentReceipt(modalResult.customerPayment)
						.then(function (response) {
							notify({
								message: 'Bank receipt saved'
							});
							loadInvoices();
						}, function (error) {
							notify({
								message: error,
								classes: 'error'
							});
						})
						.finally(function () {
							$scope.paymentReceiptLoading = false;
						});
				});
		}
	};

	$scope.creditInvoice = function (invoice) {
		AccountingSvc.showCreditInvoiceModal(invoice).then(function () {
			loadInvoices();
		});
	};

	$scope.filterOverdueClick = (days) => {
		$scope.invoiceFilters.status = 1; // overdue
		$scope.invoiceFilters.overdueBy = days;
		angular.extend($scope.invoiceParams.filters, angular.copy($scope.invoiceFilters));
	};

});
